module.exports = __webpack_public_path__ + "img/6-0-2.ea770b97.png";